import { useSelector } from 'react-redux'
import { API, Store, Flash, authSlice } from 'app'

const useGoogleLoginHelper = () => {
    const callApi = API.useAPI()
    const onSuccess = async (token) => {
        try {
            const { auth } = await callApi(API.endpoints.AUTH_INIT, { token })
            Auth.init(auth)
        } catch (err) { console.log(err) }
    }
    const onError = () => {
        console.log('Login Failed')
    }
    return { onSuccess, onError }
}

export class Auth {
    // Authentication
    static init = (data) => {
        Store.dispatch(authSlice.actions.update({ user: data.user }))
        if (data.user.role === 'ROLE_ANON') {
            Flash.add({ type: 'SUCCESS', message: 'Welcome, please sign in!' })
        } else {
            Flash.add({ type: 'SUCCESS', message: 'Signed in, welcome!' })
        }
    }
    static useGoogleLoginHelper = useGoogleLoginHelper
    static logout = async () => {
        Store.dispatch(authSlice.actions.clear())
        Flash.add({ type: 'WARNING', message: 'Signed out' })
    }
    static useGetEmail = () => {
        const auth = useSelector(state => state.auth)
        return auth.user?.email
    }

    // Authorization
    static roles = { // map each role to its level
        ROLE_SU: 4,
        ROLE_ADMIN: 3,
        ROLE_GOLD: 2,
        ROLE_USER: 1,
        ROLE_ANON: 0,
    }
    static isRoleAtleast = (role1, role2) => {
        return this.roles[role1] >= this.roles[role2]
    }
    static useGetRole = () => {
        const auth = useSelector(state => state.auth)
        return auth.role
    }
    static useCheckRole = (min_role) => {
        const auth = useSelector(state => state.auth)
        return auth.role && this.isRoleAtleast(auth.role, min_role)
    }
    static hasActiveSubscription = (user, course_name) => {
        const subs = user?.subscriptions ?? []
        var curDate = new Date()
        for (var sub of subs) {
            if (sub.course_name != course_name) {
                continue
            }
            var expiryDate = new Date(sub.expires_on)
            if ((curDate < expiryDate) && sub.status == 'ACTIVE') {
                return { allowed: true, expires_on: sub.expires_on }
            }
        }
        return { allowed: false, expires_on: null }
    }

    static useCheckCourseAccess = (course_name) => {
        const auth = useSelector(state => state.auth)
        if (this.isRoleAtleast(auth.role, 'ROLE_GOLD')) {
            return { allowed: true, message: 'Course can be accessed by gold user', expires_on: null }
        } else if (this.isRoleAtleast(auth.role, 'ROLE_USER')) {
            const { allowed, expires_on } = this.hasActiveSubscription(auth.user, course_name)
            if (allowed) {
                return { allowed: true, message: 'Course can be accessed by subscribed user', expires_on }
            } else {
                return { allowed: false, message: 'Please subscribe to access', expires_on: null }
            }
        } else {
            return { allowed: false, message: 'Please sign in and subscribe to access', expires_on: null }
        }
    }
    static useCheckResourceAccess = (course_name, resource) => {
        const auth = useSelector(state => state.auth)
        if (resource.min_role == 'ROLE_ANON') {
            return { allowed: true, message: 'Resource can be accessed by anonymous user' }
        } else if (resource.min_role == 'ROLE_USER') {
            if (!this.isRoleAtleast(auth.role, 'ROLE_USER')) {
                return { allowed: false, message: 'Sign in for free access' }
            } else {
                return { allowed: true, message: 'Resource can be accessed by signed in user' }
            }
        } else if (resource.min_role == 'ROLE_GOLD') {
            if (!this.isRoleAtleast(auth.role, 'ROLE_USER')) {
                return { allowed: false, message: 'Sign in and subscribe to access' }
            } else if (this.isRoleAtleast(auth.role, 'ROLE_GOLD')) {
                return { allowed: true, message: 'Resource can be accessed by gold user' }
            } else if (this.hasActiveSubscription(auth.user, course_name).allowed) {
                return { allowed: true, message: 'Resource can be accessed by subscribed user' }
            } else {
                return { allowed: false, message: 'Subscribe to access' }
            }
        }  else if (resource.min_role == 'ROLE_ADMIN') {
            if (!this.isRoleAtleast(auth.role, 'ROLE_ADMIN')) {
                return { allowed: false, message: 'Unauthorized' }
            } else {
                return { allowed: true, message: 'Resource can be accessed by admin user' }
            }
        } else {
            return { allowed: false, message: 'Resource error' }
        }
    }

}
